import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { Store } from '@ngrx/store';
import { AppState } from '@app/store/app.reducers';
import { TokenExpired } from '@app/store/auth/auth.actions';

@Injectable()
export class OrderHistoryRouteGuard  {

    constructor(private auth: AuthService, private router: Router, private store: Store<AppState>) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this.auth.isAuthenticated()) {
            this.store.dispatch(new TokenExpired(state.url));
            return false;
        }
        return true;
    }

    canLoad(_route: Route, segments: UrlSegment[]): boolean {
        if (!this.auth.isAuthenticated()) {
            this.store.dispatch(new TokenExpired(`/${segments.map(segment => segment.path).join('/')}`));
            return false;
        }
        return true;
    }
}
